<template>
	<div>
		<template v-if="templateForShow">
			<BaseCollapse title="發票資訊">
				<div style="margin-bottom:30px">
					<div :class="$style.invoice">
						<div class="info">
							<el-row>
								<div class="info-item">
									<span class="text orderNo">訂單 #{{ orderNoForDisplay }}</span>
								</div>
								<div v-if="defaultValue.invoice.CreateTime" class="info-item">
									<span class="title">發票日期</span>
									<span class="text">{{ defaultValue.invoice.CreateTime | formatDate }}</span>
								</div>
								<div v-if="defaultValue.invoice.InvoiceNumber" class="info-item">
									<span class="title">發票號碼</span>
									<span class="text">{{ defaultValue.invoice.InvoiceNumber }}</span>
								</div>
								<div v-if="defaultValue.invoice.RandomNum" class="info-item">
									<span class="title">隨機碼</span>
									<span class="text">{{ defaultValue.invoice.RandomNum }}</span>
								</div>
								<div v-if="defaultValue.invoice.taxType" class="info-item">
									<span class="title">發票形式</span>
									<span class="text">{{ taxTypeMap[defaultValue.invoice.taxType] }}</span>
								</div>
								<div v-if="defaultValue.invoice.taxType === 'B2C' && defaultValue.invoice.CarrierType"
									class="info-item">
									<span class="title">載具類別</span>
									<span class="text">{{ carrierTypeMap[defaultValue.invoice.CarrierType] }}</span>
								</div>
								<div v-if="defaultValue.invoice.CarrierNum && defaultValue.invoice.taxType === 'B2C' && ['0', '1'].includes(defaultValue.invoice.CarrierType)"
									:span="12" :xs="24" class="info-item">
									<span class="title">載具編號</span>
									<span class="text">{{ defaultValue.invoice.CarrierNum }}</span>
								</div>
								<div v-if="defaultValue.invoice.taxId && defaultValue.invoice.taxType === 'B2B'"
									class="info-item">
									<span class="title">統一編號</span>
									<span class="text">{{ defaultValue.invoice.taxId }}</span>
								</div>
								<div v-if="defaultValue.invoice.LoveCode && defaultValue.invoice.taxType === 'DONATE'"
									class="info-item">
									<span class="title">捐贈碼</span>
									<span class="text">{{ defaultValue.invoice.LoveCode }}</span>
								</div>
							</el-row>
						</div>
					</div>
				</div>
			</BaseCollapse>
		</template>
	</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import formatDate from '@utils/format-date'
import { taxTypeMap, carrierTypeMap } from '@utils/filter-value-to-text'
import lazyLoadComponent from '@router/lazyload-component'
export default {
	name: 'InvoiceInfoForShow',
	components: {
		BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
	},
	filters: {
		formatDate,
	},
	mixins: [],
	props: {
		/**
		 * @description 要顯示的發票訂單細節
		 */
		containerOrders: {
			type: Object,
			default: () => {
				return {}
			}
		},
		/**
		 * @description orderNo 要表現的形式
		 */
		orderType: {
			type: String,
			default: () => {
				return ""
			},
			require: true,
		}
	},
	data() {
		return {
			defaultValue: {}, // 傳進來的資料
			taxTypeMap, // 發票類別
			carrierTypeMap,
		};
	},
	provide() { },
	inject: [],
	computed: {
		/**
		 * @description template 開啟關鍵
		 */
		templateForShow() {
			if (Object.keys(this.defaultValue).length > 0 && this.defaultValue.invoice.InvoiceNumber) {
				return true
			}
			return false
		},
		orderNoForDisplay() {
			if (this.orderType === 'reservation') {
				return this.defaultValue.displayId
			}
			if (this.orderType === 'prepaid') {
				return this.defaultValue.orderNo
			}
			if (this.orderType === 'deposit') {
				return this.defaultValue.orderContainerDisplayId
			}
			return ""
		}

	},
	watch: {
		containerOrders() {
			this.defaultValue = cloneDeep(this.containerOrders)
		}
	},
	created() { },
	mounted() {
		this.defaultValue = cloneDeep(this.containerOrders)
	},
	methods: {},
};
</script>

<style lang="scss" module>
.invoice {
	:global {
		.order-id {
			font-size: 16px;
			letter-spacing: 1.6px;
			line-height: 18px;
			margin-bottom: 20px;
			font-weight: 500;
		}

		.info {
			padding: 22.5px 20px;
			background: white;

			@include touch {
				border: 1px solid #c6c6ba;
			}

			.el-col {
				padding-top: 7.5px;
				padding-bottom: 7.5px;
			}

			.info-item {
				.title {
					width: 100px;
					display: inline-block;
					color: $color-state-service;
					margin-right: 20px;
				}

				.text {
					color: $color-secondary;
				}

				.orderNo {
					font-weight: 500;
				}

				&+.info-item {
					margin-top: 15px;
				}
			}
		}
	}

	&+.invoice {
		margin-top: 40px;
	}
}</style>
